<template>
  <div class="cpt-room-default-setting cpt-use-setting">
    <div class="text-tx-1 text-[14px] font-bold leading-[normal] mb-[20px]">
      房间通知
    </div>
    <div class="sub-title">房间通知设置 (成员将默认应用，已自定义通知设置的成员除外)</div>
    <div 
      class="default-notify-setting" 
      v-tooltip="{
        text: '房间成员较多，为保证成员更好的使用体验，仅可设置为仅@被提及',
        placement: 'top',
        disabled: !onlyEditNotice,
      }"
    >
      <div class="rounded-[5px] py-[4px] bg-fl-2 relative" :class="[onlyEditNotice ? 'opacity-40 disabled' : '']">
        <div class="notify-row" @click="changeDefaultNotify(DEFAULT_NOTIFY_TYPES.all_messages)">
          <Radio class="radio-item" :active="settings.room_notify_type == DEFAULT_NOTIFY_TYPES.all_messages"/>
          <p>所有消息</p>
        </div>
        <div class="notify-row" @click="changeDefaultNotify(DEFAULT_NOTIFY_TYPES.only_at)" :class="{'active': settings.room_notify_type == DEFAULT_NOTIFY_TYPES.only_at}">
          <Radio class="radio-item" :active="settings.room_notify_type == DEFAULT_NOTIFY_TYPES.only_at"/>
          <p>仅@被提及</p>
        </div>
      </div>
    </div>
    <div class="sub-title" style="margin-top: 20px">
      频道/分组通知设置 (成员将默认应用，已自定义通知设置的成员除外)
    </div>
    <RoomNotifyList :settings="settings" :roomId="this.form.room_id" :channels="channels" :onlyEditNotice="onlyEditNotice" />
    <div class="module-divider"></div>
    <div class="default-channel-block">
      <div class="text-tx-1 text-[14px] font-bold leading-[normal] mb-[20px]">
        默认频道
      </div>
      <div class="sub-title mt-[20px]">默认频道 (成员进入房间后将默认进入此频道)</div>
      <ChannelSelector 
        v-if="initedDefaultChannelList"
        :value="settings.room_default_channel" 
        noSelectDesc="不关联频道"
        :channel_type="[...CHANNEL_TYPES.only_text_types, CHANNEL_TYPES.audio]"
        @change="handleDefaultChannelChange"
        :is_public="true"
        :need_request="false"
        :need_page="!!cur_room_data_is_big"
        :channels="channelList"
      />
    </div>
    <div class="module-divider"></div>
    <div class="text-tx-1 text-[14px] font-bold leading-[normal] mb-[20px]">
      欢迎频道
    </div>
    <div class="sub-title mt-[20px]">欢迎频道 (有人加入房间后，该频道将发送一条随机欢迎消息)</div>
    <ChannelSelector 
      v-if="initedWelcomeChannelList"
      :value="settings.welcome_channel" 
      noSelectDesc="无欢迎通知"
      @change="handleWelcomeChannelChange"
      :need_request="false"
      :channels="welcomeChannelList"
    />
    <div class="sub-title mt-[20px]">
      自定义欢迎词
    </div>
    <div 
      class="custom-welcome-content-wrapper"
      :class="{
        'row-2': twoRow
      }"
    >
      <div class="custom-welcome-content-container">
        <RichTextInput
          ref="rich-text-input"
          :style="{
            'min-width': 'calc(100% - 36px)'
          }"
          :group="group"
          :config="textConfig"
          :initValue="settings.welcome_msg"
          :transformToHtml="false"
          @updateContent="handleUpdateWelcomeContent"
          @blur="handleSaveWelcomeContent"
        />
        <ToolBar
          ref="tool-bar"
          :config="toolbarConfig"
          :group="group"
          :submitInfo="submitInfo"
          @chooseEmoji="insertEmoji"
        />
      </div>
    </div>
    <div class="module-divider"></div>
    <div class="text-tx-1 text-[14px] font-bold leading-[normal] mb-[20px]">
      显示
    </div>
    <div class="sub-title mt-[20px]">成员列表</div>
    <div class="pointer-wrapper between" style="margin-bottom: 20px;" @click="changeOffline">
      <div class="left column">
        <div class="name">展示离线成员</div>
      </div>
      <div class="right">
        <el-switch :value="settings.room_show_offline_user" style="height:16px;width:26px;"/>
      </div>
    </div>

    <template v-if="showSparkSetting">
      <div class="sub-title mt-[20px]">房间及成员活跃标识</div>
      <div class="cell mb-[20px]">
        <div class="pointer-wrapper between" @click="changeShowSpark" style="margin-bottom: 0; border-radius: 5px 5px 0 0;">
        <div class="left column">
          <div class="name">显示房间聊天火花</div>
        </div>
        <div class="right">
          <el-switch :value="!settings.hide_room_fire_flag" style="height:16px;width:26px;"/>
        </div>
      </div>
      <div class="pointer-wrapper between" @click="changeShowActivityLevel" style="margin-bottom: 0; border-radius:0 0  5px 5px;">
        <div class="left column">
          <div class="name">显示房间成员活跃标识</div>
        </div>
        <div class="right">
          <el-switch :value="!settings.hide_member_fire_flag" style="height:16px;width:26px;"/>
        </div>
      </div>
      </div>
    </template>
    <div class="pointer-wrapper between" style="margin-bottom: 20px;" @click="handleUpdateLevelSetting">
      <div class="left column">
        <div class="name">显示房间等级</div>
        <div class="desc">开启后频道列表内显示此房间的等级进度条，升级目标一目了然</div>
      </div>
      <div class="right" @click.stop="">
        <el-switch :value="isShowRoomLevel" @change="handleUpdateLevelSetting" style="height:16px;width:26px;"></el-switch>
      </div>
    </div>

    <div class="pointer-wrapper between" @click="changeCollapseAllChannel">
      <div class="left column">
        <div class="name">默认收起所有频道</div>
      </div>
      <div class="right">
        <el-switch :value="settings.default_collapse_all_channel" style="height:16px;width:26px;"/>
      </div>
    </div>

    <div class="community-block" v-if="showCommunityBlock">
      <div class="sub-title mt-[20px]">小黑盒App内展示</div>
      <div class="banner flex-[1_0_0] self-stretch bg-fl-2 py-[14px] px-[12px] rounded-t-[5px] flex-items-center gap-[12px]">
        <div class="banner-left w-[136px] h-[73px] aspect-[136/73]">
          <ChatImg src="https://imgheybox.max-c.com/dev/bbs/2025/06/30/bf722ac8b4e4937061c853f241fe0516.png" />
        </div>
        <div class="banner-right">
          <div class="right-top">
            <div class="right-top-title text-tx-2 text-[14px] font-semibold leading-[normal]">小黑盒个人主页展示</div>
            <div class="right-top-desc text-tx-3 text-[12px] leading-[16px] mt-[3px]">开启后，其他用户可通过房主的小黑盒个人页加入房间的默认频道</div>
          </div>
          <div class="right-bottom mt-[8px] pointer w-fit flex-items-center gap-[4px] bg-op-1 px-[8px] py-[5px] rounded-[3px] text-tx-2-1 text-[12px]" @click="handleSwitchAppShow">
            <el-switch class="right-bottom-switch" :value="appShow" style="height:16px;width:26px;" />
            已{{ appShow ? '开启' : '关闭' }}
          </div>
        </div>
      </div>
      <div class="pointer-wrapper !rounded-t-none between" @click="handleSwitchCommunityRoom">
        <div class="left column">
          <div class="name">社群房间</div>
          <div class="desc">开启后，加入房间的成员可在小黑盒消息中心进入默认频道</div>
        </div>
        <div class="right">
          <el-switch :value="isCommunityRoom" style="height:16px;width:26px;"></el-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { CHANNEL_TYPES } from '@/common/constants/channel';
import { getChannelIcon } from "_lib/constants/channel";

import { editRoomDefaultSetting, editRoomSetting, editCommunityRoom, editAppShowInUserPage } from "_api/room/index"
import RoomNotifyList from '../components/RoomNotifyList'
import Radio from '_com/menu/Radio'
import { ROLE_TYPES } from '_lib/constants/role';
import EventBus from '_lib/EventBus';
import ChannelSelector from '@/components/busy/channelSelector'
import ToastInner from '_com/func/ToastInner.vue'
import RichTextInput from '_com/richTextInput/index.vue';
import ToolBar from '_com/richTextInput/components/ToolBar.vue';

import { COMMUNITY_ROOM_INTERACT_TYPE } from '_lib/constants/room';
export default {
  name: 'RoomDefaultSetting',
  components: {
    Radio,
    RoomNotifyList,
    ChannelSelector,
    RichTextInput,
    ToolBar,
  },
  data() {
    return {
      channelList: [],
      welcomeChannelList: [],
      updateSelectorKey: 0,
      last_update_settings: null,
      DEFAULT_NOTIFY_TYPES: {
        all_messages: '1',
        only_at: '2',
        no_notify: '3'
      },
      setting_lock: false,
      initedDefaultChannelList: false,
      initedWelcomeChannelList: false,

      textConfig: {
        placeholder: '请输入自定义欢迎词',
        markdown: {
          // markdown配置
          h1: true, // 一级标题
          h2: true, // 二级标题
          bold: true, // 加粗
          italic: true, // 斜体
          ol: true, // 有序列表
          ul: true, // 无序列表
          underline: true, // 下划线
          code: true, // 代码
        },
        lineBreak: true, // 是否支持换行
        breakWay: 'enter', // 换行方式, enter: 回车换行, shiftEnter: shift+回车换行
        emoji: true, // 允许插入emoji
        link: false, // 允许插入链接
        image: false, // 允许插入图片
        at: false, // 允许艾特, 输入@时触发
        atTypes: ['room', 'role'], // 艾特类型 room: 房间, role: 权限组, friend: 好友
        channel: false, // 允许插入频道, 输入#时触发
        autoFocus: false, // 是否自动聚焦
        userCard: false, // 是否支持点击艾特用户弹出用户卡片
        imageInMarkdown: false, // markdown模式下是否支持插入图片
      },
      toolbarConfig: {
        emoji: true, // 允许插入emoji
        emojiCaller: 'OfficialAndHiddenSticker', // 表情选择器类型
      },
      MAX_LENGTH: 50,
      welcomeContent: '',
      group: 'custom-welcome-content',

      submitInfo: {
        disabled: false,
      },

      twoRow: false,
      CHANNEL_TYPES,
    }
  },
  props: ['form', 'show', 'channels'],
  computed: {
    settings() {
      const room_setting = this.form?.room?.room_setting || {}
      const { 
        room_default_channel,
        welcome_channel,
        room_notify_type,
        room_show_offline_user,
        room_show_spark,
        room_show_activity_level,
        hide_member_fire_flag,
        hide_room_fire_flag,
        default_collapse_all_channel,
        welcome_msg,
      } = room_setting
      return {
        room_default_channel: room_default_channel || '0', 
        welcome_channel: welcome_channel || '0', 
        room_notify_type, 
        room_show_offline_user: !!Number(room_show_offline_user), 
        room_show_spark: !!Number(room_show_spark), 
        room_show_activity_level: !!Number(room_show_activity_level), 
        hide_member_fire_flag,
        hide_room_fire_flag,
        default_collapse_all_channel: !!Number(default_collapse_all_channel),
        welcome_msg: welcome_msg || ''
      }
    },
    onlyEditNotice() {
      return this.form.room.member_count > (this.global_config?.big_room_notify_limit ?? 500)
    },
    select_channel () {
      return this.channelList.find(item => item.channel_id === this.settings.room_default_channel) || {}
    },
    select_welcome_channel () {
      return this.channelList.find(item => item.channel_id === this.settings.welcome_channel) || {}
    },
    showSparkSetting(){
      return !this.form.room.is_public
    },
    isShowRoomLevel() {
      return !!this.form.room?.room_setting?.show_room_level
    },
    showCommunityBlock() {
      return Boolean(this.form.communitySetting)
    },
    isCommunityRoom() {
      return Boolean(this.form.communitySetting?.is)
    },
    appShow() {
      return Boolean(this.form.communitySetting?.show)
    },
    ...mapGetters(['cur_roles_list', 'all_notify_settings', 'guidance_channel_list', 'cur_room_data_is_big', 'global_config', 'setting_data']),
  },
  watch: {
    channels: {
      handler(v) {
        if(v.length === 0) return
        this.channelList = [{
          channel_id: '0',
          channel_name: '不关联频道'
        }]
        this.welcomeChannelList = [{
          channel_id:'0',
          channel_name:'无欢迎通知'
        }]
        this.initChannels()
        this.initWelcomeChannels()
      },
      immediate: true
    }
  },
  mounted() {
    if(!this.last_update_settings){
      this.last_update_settings = JSON.parse(JSON.stringify(this.settings))
    }
    setTimeout(() => {
      this.updateSelectorKey++
    }, 300)
    this.welcomeContent = this.settings.welcome_content
  },
  methods: {
    initChannels() {
      this.channels.forEach(item => {
        if (this.judgeCanShow(item, [...CHANNEL_TYPES.only_text_types, CHANNEL_TYPES.audio])) {
          this.channelList.push(item)
          item.icon_class = getChannelIcon(item)
        }
      })
      if (!this.channelList.find(item => item.channel_id == this.settings?.room_default_channel)) {
        this.handleUpdateDefaultSetting({type: 'room_default_channel', value: '0'})
      }
      this.initedDefaultChannelList = true
    },
    initWelcomeChannels() {
      this.channels.forEach(item => {
        if (this.judgeCanShow(item, [CHANNEL_TYPES.text])) {
          this.welcomeChannelList.push(item)
          item.icon_class = getChannelIcon(item)
        }
      })
      if (!this.welcomeChannelList.find(item => item.channel_id == this.settings.welcome_channel)) {
        this.handleUpdateDefaultSetting({type: 'welcome_channel', value: '0'})
      }
      this.initedWelcomeChannelList = true
    },
    handleWelcomeChannelChange(value) {
      this.handleUpdateDefaultSetting({type: 'welcome_channel', value})
    },
    handleDefaultChannelChange(value) {
      this.handleUpdateDefaultSetting({type: 'room_default_channel', value})
    },
    async changeDefaultNotify(value) {
      if (this.onlyEditNotice) return
      this.handleUpdateDefaultSetting({type: 'room_notify_type', value})

      // 更新本地的数据
      let currentNotifySetting = this.$unread.getNotifySetting({
        room_id: this.form.room_id,
      }, false) || { notify_type: 2 }
      currentNotifySetting.notify_type = +value
       // 获取当前所有的通知设置
      let all_notify_settings = this.all_notify_settings || {};
      // 获取指定房间的设置，如果不存在则创建一个空对象
      let room_settings = all_notify_settings[this.form.room_id] || {};

      all_notify_settings[this.form.room_id] = { ...room_settings, ...currentNotifySetting };

      this.SET_ALL_NOTIFY_SETTINGS(all_notify_settings);

      this.$unread.updateUnreadStateCache({
        room_id: this.form.room_id,
      })
      EventBus.$emit('Update_Room_Notify')
    },
    changeOffline () {
      const value = !this.settings.room_show_offline_user
      this.handleUpdateDefaultSetting({type: 'room_show_offline_user', value})
    },
    editChannelDefaultSetting(type, newV) {
      if (this.last_update_settings && newV === this.last_update_settings[type]) {
        return
      }
      let value = ''
      const transList = ['room_show_offline_user', 'room_show_spark', 'room_show_activity_level', 'hide_room_fire_flag', 'hide_member_fire_flag', 'default_collapse_all_channel']
      if (transList.includes(type)) {
        value = newV ? '1' : '0'
      } else {
        value = newV
      }
      editRoomDefaultSetting({}, {
        setting: type,
        room_id: this.form.room.room_id,
        value,
      }).then(res => {
        if (res.data.status === 'ok') {
          this.last_update_settings[type] = value
        } else {
          this.redrawSetting(type)
        }
      }).catch(err => {
        this.redrawSetting(type)
      })
    },
    handleUpdateDefaultSetting({type, value, isRedraw}){
      const roomData = this.form.room
      roomData['room_setting'][type] = value
      this.$emit('updateSetting', {
        key: 'room',
        value: roomData
      })
      !isRedraw && this.editChannelDefaultSetting(type, value)
    },
    redrawSetting(type) {
      const value = this.last_update_settings[type]
      this.handleUpdateDefaultSetting({type, value, isRedraw: true})
    },
    judgeCanShow(channel, typeLimit = []){
      const res = !channel.is_private && !channel.password && typeLimit.includes(channel.channel_type)
      if(res) {
        const everyoneRole = this.cur_roles_list.find(
          (role) => role.type === ROLE_TYPES.everyone
        );
        return !this.guidance_channel_list.includes(channel.channel_id) && this.$permission.judgeRole({
          role: everyoneRole,
          type: "ViewingChannel",
          channel_data: channel,
        })
      } else {
        return false
      }
    },
    changeShowSpark () {
      const value = !this.settings.hide_room_fire_flag
      this.handleUpdateDefaultSetting({type: 'hide_room_fire_flag', value})
      EventBus.$emit("Update_Hide_Room_Fire_Flag", this.form.room, value)
    },
    changeShowActivityLevel () {
      const value = !this.settings.hide_member_fire_flag
      this.handleUpdateDefaultSetting({type: 'hide_member_fire_flag', value})
    },
    handleUpdateLevelSetting() {
      const newVal = !this.isShowRoomLevel
      const newData = this.form.room
      newData['room_setting']['show_room_level'] = newVal
      this.$emit('updateSetting', {
        key: 'room',
        value: newData
      })
      this.editRoomSetting(newVal)
    },
    editRoomSetting (v) {
      if (this.setting_lock) return
      this.setting_lock = true

      let body = {
        room_id: this.form.room.room_id,
        setting: 'show_room_level',
        value: v ? 1 : 0
      }
      editRoomSetting({}, body).then(res => {
        this.setting_lock = false
      })
    },
    async handleSwitchCommunityRoom() {
      const newVal = !this.isCommunityRoom
      if(!newVal) {
        if(this.appShow) {
          this.$toast('请先关闭小黑盒个人主页展示开关');
          return;
        }
        this.$query({
          config: {
            title: '关闭后，所有加入社群的用户将无法在消息列表内看见本社群，确认关闭？',
            confirm: {
              text: '关闭',
              type: 'alert',
            },
            cancel: {
              text: '取消'
            }
          },
          confirmCB: () => {
            this.handleSendSwitchCommunityRoom(newVal)
          }
        })
        return;
      } else {
        this.handleSendSwitchCommunityRoom(newVal)
      }
    },
    async handleSendSwitchCommunityRoom(newVal) {
      const { data: { status, msg, result } } = await editCommunityRoom(
        {
          _notip: 1,
        },
        {
          room_id: this.form.room.room_id,
          set: newVal
        }
      )
      if(status === 'ok') {
        this.$emit('updateSetting', {
          key: 'communitySetting',
          value: {
            is: newVal,
            show: this.appShow
          },
        })
      } else {
        const {
          htmlContent,
          clickCb
        } = this.handleGetToastInnerData(result?.interaction_type)
        this.handleShowGuideToast(msg, htmlContent, clickCb)
      }
    },
    async handleSwitchAppShow() {
      const newVal = !this.appShow
      const { data: { status, msg, result } } = await editAppShowInUserPage(
        {
          _notip: 1,
        },
        {
          room_id: this.form.room.room_id,
          show: newVal
        }
      )
      if(status === 'ok') {
        this.$emit('updateSetting', {
          key: 'communitySetting',
          value: {
            is: this.isCommunityRoom,
            show: newVal
          },
        })
      } else {
        const {
          htmlContent,
          clickCb
        } = this.handleGetToastInnerData(result?.interaction_type)
        this.handleShowGuideToast(msg, htmlContent, clickCb)
      }
    },
    changeCollapseAllChannel() {
      const value = !this.settings.default_collapse_all_channel
      this.handleUpdateDefaultSetting({type: 'default_collapse_all_channel', value})
    },
    handleGetToastInnerData(type) {
      switch(type) {
        case COMMUNITY_ROOM_INTERACT_TYPE.SWITCH_COMMUNITY_ROOM:
          return {
            htmlContent: '前往开启',
            clickCb: () => {
              this.$emit('scrollAndHighlight', '.community-block')
            }
          }
        case COMMUNITY_ROOM_INTERACT_TYPE.ALREADY_HAD_PAGE_ROOM:
          return {
            htmlContent: '',
          }
        case COMMUNITY_ROOM_INTERACT_TYPE.SET_PUBLIC_ROOM: {
          return {
            htmlContent: '前往公开',
            clickCb: () => {
              this.$emit('scrollAndHighlight', '.public-block')
            }
          }
        }
        case COMMUNITY_ROOM_INTERACT_TYPE.SET_DEFAULT_CHANNEL: {
          return {
            htmlContent: '前往设置',
            clickCb: () => {
              this.$emit('scrollAndHighlight', '.default-channel-block')
            }
          }
        }
        case COMMUNITY_ROOM_INTERACT_TYPE.TURN_OFF_VERIFICATION: {
          return {
            htmlContent: '前往关闭',
            clickCb: () => {
              EventBus.$emit('Change_Choose_Item', 'safety-manage')
            }
          }
        }
        default: {
          return {
            htmlContent: '',
          }
        }
      }
    },
    handleShowGuideToast(title, htmlContent, clickCb) {
      const toastOptions = {
        timeout: 5000,
      }

      const renderContent = (title, htmlContent, clickCb) => {
        return this.$createElement(ToastInner, {
          props: {
            title,
            showSlot: !!htmlContent
          },
          scopedSlots: {
            default: () =>
              this.$createElement(
                'div',
                {
                  domProps: {
                    innerHTML: htmlContent,
                  },
                  class: 'text-bd-tx text-[14px] font-semibold leading-[normal] pointer',
                  on: {
                    click: (e) => {
                      if (clickCb) clickCb(e);
                    },
                  },
                }
              ),
          }
        })
      }

      const content = renderContent(title, htmlContent, clickCb)

      // 使用toast方法，不用类型方法
      this.$toast(content, '', toastOptions)
    },
    handleUpdateWelcomeContent(v) {
      this.welcomeContent = v
      const pTags = v.match(/<p[^>]*>.*?<\/p>/g)

      this.twoRow = pTags && pTags.length >= 2
    },
    insertEmoji (emoji_info) {
      if (emoji_info.group_type === 'emoji') {
        this.$refs['rich-text-input'].ensureHbEditorLoaded().then((richText) => {
          richText.insertEmoji(emoji_info)
        })
      }
    },
    /**
     * @description 更新房间设置中的自定义欢迎词
     * 将欢迎词中的空p标签去除
     */
    handleSaveWelcomeContent() {
      const emptyPTagRegex = /<p[^>]*><\/p>/g
      const newContent = this.welcomeContent.replace(emptyPTagRegex, '')
      this.editChannelDefaultSetting('welcome_msg', newContent)
    },
    ...mapMutations([
      'SET_CUR_ROOM_DATA',
      'SET_ALL_NOTIFY_SETTINGS',
      'SET_SETTING_DATA_PARAM',
    ])
  }
}
</script>

<style lang="scss">
.cpt-room-default-setting {
  .default-notify-setting {
    .notify-row {
      display: flex;
      align-items: center;
      width: 100%;
      height: 42px;
      padding: 0 12px;
      cursor: pointer;
      .radio-item {
        width: auto;
        padding: 0;
        .radio {
          border-color: $d-op-2;
        }
      }
      p {
        margin-left: 6px;
        color: $d-tx-2;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        white-space: nowrap;
      }
    }
    .disabled {
      .notify-row {
        cursor: not-allowed;
      }
    }
  }
  .default-channel-setting {
    &.no-select {
      .el-select {
        .el-input {
          .el-input__inner {
            padding-left: 12px !important;
            color: $d-tx-2 !important;
            background-color: $d-op-s2 !important;
          }
        }
      }
    }
    .el-select-dropdown {
      min-width: 546px !important;
    }
    .channel-info-wrapper {
      display: flex;
      align-items: center;
      &.perfix {
        position: relative;
        top: 13px;
        left: 4px;
        .left-icon {
          color: $d-tx-1;
        }
      }
      &.active {
        .left-icon, .channel-name {
          color: $d-tx-1;
        }
        .group-name {
          color: $d-tx-2;
        }
      }
      .left-icon {
        font-size: 16px;
        margin-right: 6px;
        transform: none;
        color: $d-tx-4;
      }
      .channel-name {
        font-size: 14px;
        color: $d-tx-2;
        margin-right: 8px;
        max-width: 230px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .group-name {
        font-size: 12px;
        color: $d-tx-3;
        position: relative;
        max-width: 230px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .radio-item {
        margin-left: auto;
        width: auto;
      }
    }
  }
  .custom-welcome-content-wrapper {
    position: relative;
    &.row-2 {
      .cpt-rich-text-editor {
        width: 100%;
      }
    }
    background-color: $d-op-s2;
    border-radius: 5px;
    .custom-welcome-content-container {
      height: 100%;
      overflow: hidden;
    }
    .cpt-rich-text-editor {
      display: inline-block;
      width: auto;
      transform: translateY(3px);
      .hb-editor-wrapper {
        min-height: 40px;
        max-height: 350px;
        .hb-editor {
          padding: 8px 0;
        }
      }
    }
    .cpt-rich-text-toolbar {
      position: static;
      justify-content: flex-end;
      float: right;
      height: 46px;
      bottom: 18px;
      padding-right: 8px;
    }
  }
}

</style>